import { Link } from "react-router-dom";
import classroom from "../../assets/images/facilities/classroom.jpg";
import lab from "../../assets/images/facilities/computer_lab.jpg";
import science_lab from "../../assets/images/facilities/lab.jpg";
import library from "../../assets/images/facilities/library.jpg";
import sports from "../../assets/images/facilities/sports.jpg";

const Facility = () => {
  return (
    <section className="course-list-view py-80 bg-white">
      <div className="container">
        <div className="row gy-4">
          <div className="col-xl-4 col-sm-6">
            <div className="scale-hover-item bg-main-25 rounded-16 p-12 h-100 border border-neutral-30">
              <div className="course-item__thumb rounded-12 overflow-hidden position-relative">
                <img
                  src={classroom}
                  alt="NPS Kudlu Classrooms"
                  className="scale-hover-item__img rounded-12 cover-img transition-2"
                />
              </div>
              <div className="pt-32 pb-24 px-16 position-relative">
                <h4 className="mb-10">Classroom</h4>
                <p>
                  Classrooms at NPS Kudlu – The Best CBSE School in Bangalore
                  are well resourced and spacious. They are designed in such a
                  way that each student gets the teacher’s maximum
                  individualized attention. Students are encouraged to decorate
                  their classrooms and display their creative work on the
                  boards.
                </p>
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-sm-6">
            <div className="scale-hover-item bg-main-25 rounded-16 p-12 h-100 border border-neutral-30">
              <div className="course-item__thumb rounded-12 overflow-hidden position-relative">
                <img
                  src={lab}
                  alt="Computer Lab"
                  className="scale-hover-item__img rounded-12 cover-img transition-2"
                />
              </div>
              <div className="pt-32 pb-24 px-16 position-relative">
                <h4 className="mb-10">Computer Lab</h4>
                <p>
                  The computer laboratory at National Public School Kudlu has
                  over a 100 computers with a dedicated broadband Internet
                  connection for students. Student usage of media and technology
                  are monitored and supervised by teachers.
                </p>
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-sm-6">
            <div className="scale-hover-item bg-main-25 rounded-16 p-12 h-100 border border-neutral-30">
              <div className="course-item__thumb rounded-12 overflow-hidden position-relative">
                <img
                  src={science_lab}
                  alt="Science Laboratory"
                  className="scale-hover-item__img rounded-12 cover-img transition-2"
                />
              </div>
              <div className="pt-32 pb-24 px-16 position-relative">
                <h4 className="mb-10">Science Lab</h4>
                <p>
                  The science laboratory at NPS Kudlu – one of the Top CBSE
                  Schools in Bangalore provides a space for experiential and
                  hands on learning for students. There are separate
                  workstations for Physics, Chemistry and Biology.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row gy-4 mt-3 justify-content-center">
          <div className="col-xl-4 col-sm-6">
            <div className="scale-hover-item bg-main-25 rounded-16 p-12 h-100 border border-neutral-30">
              <div className="course-item__thumb rounded-12 overflow-hidden position-relative">
                <img
                  src={library}
                  alt="School Library"
                  className="scale-hover-item__img rounded-12 cover-img transition-2"
                />
              </div>
              <div className="pt-32 pb-24 px-16 position-relative">
                <h4 className="mb-10">Library</h4>
                <p>
                  The library is the main resource centre for students and can
                  accommodate over 150 students at a time. Students have access
                  to a vast collection of fiction and non-fiction books,
                  reference books, academic journals, periodicals, magazines,
                  newspapers and textbooks. Specialist classrooms can be found
                  for Math, music, dance, theatre, and art. All students have an
                  opportunity to use these specialist classrooms.
                </p>
              </div>
            </div>
          </div>

          <div className="col-xl-4 col-sm-6">
            <div className="scale-hover-item bg-main-25 rounded-16 p-12 h-100 border border-neutral-30">
              <div className="course-item__thumb rounded-12 overflow-hidden position-relative">
                <img
                  src={sports}
                  alt="School Playground"
                  className="scale-hover-item__img rounded-12 cover-img transition-2"
                />
              </div>
              <div className="pt-32 pb-24 px-16 position-relative">
                <h4 className="mb-10">Sports</h4>
                <p>
                  Sports facilities at NPS Kudlu include basketball, volleyball,
                  badminton, gymnastics, cricket, football, throw ball,
                  aerobics, taekwondo and yoga.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Facility;
